import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import React from 'react';
import { SignupContext } from '@jetshop/core/components/Auth/signup-context';
export default function useLoginFields() {
    const context = React.useContext(SignupContext);
    // Throw if this hook is used from outside the signup form container (which
    // contains the context provider)
    throwErrorInDev(typeof context === 'undefined', 'useLoginFields can only be used from inside `SignupFormContainer`');
    const { loginFields } = context;
    const fields = loginFields.map(field => {
        return Object.assign(Object.assign({}, field), { inputProps: {
                key: field.id,
                type: field.type,
                name: field.name,
                label: field.label,
                required: field.required
            } });
    });
    return { fields };
}
//# sourceMappingURL=useLoginFields.js.map